import React, { useState } from "react";
import { Field, useFormik } from "formik";
import {
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import _ from "lodash";
import Title from "../../../../components/title";
import * as Yup from "yup";
import { store } from "../../../../redux/storeConfig/store";
import { toastr } from "react-redux-toastr";
import { useSelector } from "react-redux";

const PartialPaymentDialog = ({
  setFieldValue,
  values,
  currentRemainingAmount,
}) => {
  const { loginUser } = useSelector((state) => state.login);
  const { permissions } = useSelector((state) => state.permissions);
  const handlePaidAmount = (e) => {
    if (parseFloat(e.target.value) > currentRemainingAmount) {
      toastr.error("Received amount cannot be more than remaining amount");
      return;
    }

    if (parseFloat(e.target.value) > 0) {
      setFieldValue("receivedAmount", parseFloat(e.target.value));
      setFieldValue(
        "remainingAmount",
        currentRemainingAmount - parseFloat(e.target.value)
      );
    } else {
      setFieldValue("receivedAmount", null);
      setFieldValue("remainingAmount", currentRemainingAmount);
    }
  };

  return (
    <>
      <div className="subscription-plan-list-element">
        <div className="">
          <div className="form-check form-check-inline custom-btn-radio">
            <Input
              type="radio"
              name="paymentStatus"
              id="fRadio"
              value={values.paymentStatus}
              className="form-check-input"
              onClick={(e) => setFieldValue("paymentStatus", "F")}
            />
            <label className="form-check-label label-blk" for="fRadio">
              Full Settelment
            </label>
          </div>
        </div>
      </div>
      {(loginUser.role == "STAFF" && !permissions["S-SAL-PAPAY"]) ||
      (loginUser.role == "SUB_ADMIN" && !permissions["S-SAL-PAPAY"]) ? null : (
        <div className="subscription-plan-list-element">
          <div className="">
            <div className="form-check form-check-inline custom-btn-radio">
              <Input
                type="radio"
                name="paymentStatus"
                id="pRadio"
                value={values.paymentStatus}
                className="form-check-input"
                onClick={(e) => setFieldValue("paymentStatus", "P")}
              />
              <label className="form-check-label label-blk" for="pRadio">
                Partial Settelment
              </label>
            </div>
          </div>
        </div>
      )}

      {values.paymentStatus === "P" && (
        <Row className="members-date-edit-wrapper blk-padding-y pt-0 mt-4">
          <Col md={6}>
            <Label
              className="grey-background"
              style={{
                background: "white",
                mixBlendMode: "normal",
              }}
            >
              {"Received Amount"}
            </Label>{" "}
            <Input
              // disabled={selectedPackages.length === 0}
              type="number"
              name={"receivedAmount"}
              placeholder={"Start Typing"}
              max={values?.currentRemainingAmount}
              value={values.receivedAmount}
              onChange={(e) => handlePaidAmount(e)}
              id="receivedAmount"
              className="form-control col-xs-6"
            />
            {/* </FormGroup> */}
          </Col>

          <Col md={6}>
            <Label
              className="grey-background"
              style={{
                background: "white",
                mixBlendMode: "normal",
              }}
            >
              {"Remaining Amount"}
            </Label>{" "}
            <Input
              type="number"
              disabled
              name={"remainingAmount"}
              value={values?.remainingAmount}
              placeholder={"Remaining Amount"}
              id="remainingAmount"
              className="form-control col-xs-6"
            />
            {/* </FormGroup> */}
          </Col>
          {/* {errors.receivedAmount && touched.receivedAmount ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >{`${errors.receivedAmount}`}</div>
                ) : null} */}
        </Row>
      )}
    </>
  );
};
export default PartialPaymentDialog;
